//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EventBus from "@/event-bus.js";
import { signOut } from "@/utils/auth.js";
import store from "@/store";
import { contextualHelp } from "@/utils/contextualHelp.js";

import ArMenuItem from "@/components/layout/MenuItem";

export default {
  name: "DefaultLayout",
  mounted() {
    EventBus.$on("page-loaded", payLoad => {
      this.updateData(contextualHelp[payLoad.page]);
      if (this.$q.screen.lt.md) this.left = false;
    });
  },
  computed: {
    currentUser() {
      const user = store.getters["auth/getUser"]
        ? store.getters["auth/getUser"].internal
        : null;
      if (user)
        return `${user.nombre} ${user.primer_apellido} ${user.segundo_apellido}`;
      return null;
    }
  },
  destroyed() {
    EventBus.$off("page-loaded");
    EventBus.$off("dynamic-help");
  },
  data() {
    return {
      left: false,
      help: false,
      dynamicHelp: "",
      menuList: [
        {
          icon: "home",
          label: "Encuestas para Revisar",
          separator: false,
          link: "/home",
          show: () => {
            if (store.getters["auth/getUser"]) {
              const userGroup =
                store.getters["auth/getUser"].attributes["custom:group"];
              return userGroup === "medicos" || userGroup === "admins";
            }
            return false;
          }
        },
        {
          icon: "person",
          label: "Mis Pacientes",
          separator: false,
          link: "/pacientes",
          show: () => {
            if (store.getters["auth/getUser"]) {
              const userGroup =
                store.getters["auth/getUser"].attributes["custom:group"];
              return userGroup === "medicos" || userGroup === "admins";
            }
            return false;
          }
        },
        {
          icon: "home",
          label: "Mis Encuestas",
          separator: false,
          link: "/encuestas",
          show: () => {
            if (store.getters["auth/getUser"]) {
              const userGroup =
                store.getters["auth/getUser"].attributes["custom:group"];
              return userGroup === "pacientes" || userGroup === "admins";
            }
            return false;
          }
        },
        {
          icon: "museum",
          label: "Encuestas Tipo",
          separator: false,
          link: "/encuestas-tipo",
          show: () => {
            if (store.getters["auth/getUser"]) {
              const userGroup =
                store.getters["auth/getUser"].attributes["custom:group"];
              return userGroup === "medicos" || userGroup === "admins";
            }
            return false;
          }
        }
      ]
    };
  },
  components: {
    ArMenuItem
  },
  methods: {
    logout() {
      signOut();
    },
    checkShow() {
      if (this.$q.screen.gt.sm) return true;
      else {
        if (this.left) return false;
      }
      return true;
    },
    updateData(help) {
      if (!help) {
        this.dynamicHelp = `<span class="text-uppercase text-weight-bold">INFORMACIÓN</span><br><br>
    Ayuda contextual no disponible<br><br>`;
      } else {
        this.dynamicHelp = help;
      }
    }
  }
};
